
	import {
		Component,
		Model,
		Prop,
		Vue,
		Watch
	} from "vue-property-decorator";
	
	import {validatePhone} from '@/utils/valida.ts';

	import Dialog from '@/components/dialog.vue';

	import {
		rolelist,
		employeeDetail,
		employeeSave,
		employeeEdit
	} from '@/api/auth.ts';

	@Component({
		name: 'add-employee',
		components: {
			'employee-dialog': Dialog
		}
	})

	export default class AuthRoles extends Vue {
		
		private checkPhone:any = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入手机号'));
			}else if (!validatePhone(value)){
				return callback(new Error('请输入正确的手机号'));
			}else{
				return callback();
			}
		};
		private checkPassword:any = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请设置登录密码'));
			}else if (value.length < 6){
				return callback(new Error('请设置不低于6位数的密码，建议数字+字母结合'));
			}else{
				return callback();
			}
		};
		
		// public $refs!: {
		// 	ref: ruleForm
		// }
		
		@Model('change') visible!: Boolean;
		@Prop({default: 0}) id!: Number;
		private showDialog = false;
		private loading = false;
		private titleText = '';
		private roleList = [];
		private ruleForm = {
			name: '',
			phone: '',
			password: '',
			roleId: ''
		}
		private rules = {
			name: [{
				required: true,
				message: '请输入员工姓名',
				trigger: 'blur'
			}],
			phone: [{
				required: true,
				validator: this.checkPhone,
				trigger: 'blur'
			}],
			password: [{
				required: true,
				validator: this.checkPassword,
				trigger: 'blur'
			}],
			roleId: [{
				required: true,
				message: '请选择员工角色',
				trigger: 'blur'
			}]
		}

		@Watch('visible')
		private async onChangeVisible(e) {
			this.showDialog = e;

			if (this.showDialog) {

				this.getRoleList();

				if (this.id) {
					this.titleText = '编辑成员';
					this.getDetail();
				} else {
					this.ruleForm.name = '';
					this.ruleForm.phone = '';
					this.ruleForm.roleId = '';
					this.ruleForm.password = '';
					this.titleText = '新增成员';

				}
			}
		}

		//获取角色列表
		private async getRoleList() {
			try {
				const res: any = await rolelist({
					Skip: 0,
					Take: 99999
				})
				this.roleList = res.Result.Results;
			} catch (err) {}
		}

		//编辑的时候  获取角色详情
		private async getDetail() {
			try {
				const res: any = await employeeDetail({
					Id: this.id
				})

				this.ruleForm.name = res.Result.EmployeeName;
				this.ruleForm.phone = res.Result.Phone;
				this.ruleForm.roleId = res.Result.EmployeeRoleId;

			} catch (err) {

			}
		}


		//关闭弹框
		private handleClose() {
			this.showDialog = false;
			this.$emit('change', false)
		}

		//保存
		private handleSave() {
			let ref:any = this.$refs['ruleForm'];
			ref.validate((valid) => {
				if (valid) {
					if (this.id){
						this.editData();
					}else{
						this.addData();
					}
					
				}
			});
		}
		private async editData() {
			try {
				this.loading = true;

				const params: any = {
					Id: this.id,
					EmployeeRoleId: this.ruleForm.roleId,
					EmployeeName: this.ruleForm.name,
					Phone: this.ruleForm.phone,
				}

				const res: any = await employeeEdit(params);

				this.$message.success('编辑成功');
				this.$emit('reload');
				this.handleClose();

			} catch (err) {
				this.loading = false;
			}
		}
		private async addData() {
			try {
				this.loading = true;
		
				const params: any = {
					EmployeeRoleId: this.ruleForm.roleId,
					EmployeeName: this.ruleForm.name,
					Phone: this.ruleForm.phone,
					Password: this.ruleForm.password,
					EmployeeState: 0
				}
		
				const res: any = await employeeSave(params);
		
				this.$message.success('添加成功');
				this.$emit('reload');
				this.handleClose();
		
			} catch (err) {
				this.loading = false;
			}
		}
	}
